function eventLinkFor(id: number): string {
  return "/event/" + id;
}

function ticketLinkFor(id: number): string {
  return "/ticket/" + id;
}

export { eventLinkFor, ticketLinkFor };
